import * as React from "react";
import ProductTile from "./productTile";

const ProductList = ({ data }) => {
  switch (data.layout) {
    case "List":
      return (
        <div
          className="flex flex-row justify-start items-start container flex-wrap product-list"
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "transparent",
          }}
        >
          {data.title && (
            <div className="container">
              {" "}
              <h2>{data.title}</h2>
            </div>
          )}
          {data.products.map((product, index) => {
            return (
              product.fields && (
                <>
                  <ProductTile
                    key={`product-tile-${index}`}
                    url={product.url}
                    urltext={data.urltext || `Flere oplysninger`}
                    image={{
                      href: product.fields.productData.salsify_digital_assets[0]
                        .salsify_url,
                      title: product.fields.productData.Product_Title,
                    }}
                    title={product.fields.productData.Product_Title}
                    description={product.fields.productData.Description_Short}
                  />
                </>
              )
            );
          })}
        </div>
      );
    case "Slider":
      return (
        <div
          className="col-span-12 w-full product-list"
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "transparent",
          }}
        >
          {data.title && (
            <div className="w-full container mx-auto">
              <h2 className="title">{data.title}</h2>
            </div>
          )}
          <div className="w-full flex flex-row flex-nowrap overflow-x-scroll overflow-y-hidden justify-between container mx-auto">
            {data.products.map((product, index) => {
              return (
                product.fields && (
                  <>
                    <ProductTile
                      key={`product-tile-${index}`}
                      url={product.url}
                      urltext={data.urltext || `Flere oplysninger`}
                      image={{
                        href: product.fields.productData
                          .salsify_digital_assets[0].salsify_url,
                        title: product.fields.productData.Product_Title,
                      }}
                      title={product.fields.productData.Product_Title}
                      description={product.fields.productData.Description_Short}
                    />
                  </>
                )
              );
            })}
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default ProductList;
